module.exports = __webpack_public_path__ + "img/app4.b6ade149.png";